import { useContext, useRef } from 'react'
import { SidebarContext } from '../../../lib/Context'
import Configuration from '../Configuration/Configuration'
import { useSheet } from '../lib/Hooks/Sheet'
import MenuButton from '../MenuButton'

const SpreadsheetMenu = () => {
  const { data: spreadsheet } = useSheet()
  const { showSidebar } = useContext(SidebarContext)
  const ref = useRef(null)

  return (
    <div className='flex flex-wrap md:justify-end mb-4 mt-2 sm:mt-0'>
      <div className='relative' ref={ref}>
        <MenuButton
          sheet={spreadsheet!}
          icon='MdSettings'
          onClick={() => showSidebar(<Configuration sheet={spreadsheet!} />)}
        />
      </div>
    </div>
  )
}

export default SpreadsheetMenu
